<template>
  <div style="height: 100%;">
    <!--能效-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span style="">能效</span>
    </div>
    <el-row style="padding-top: 5px;">
      <el-col :span="2" style="width: 10%;height: 53px"></el-col>
      <el-col :span="8" style="text-align: center;">
        <div style="height: 53px;">
          <div
            style="border-bottom: 1px solid rgba(41, 159, 251, .2);width: 30%;height:100%;padding-top:10px;padding-right:10px;display: inline-block;text-align: right">
            <img src="../../../assets/images/comprehensive/总能耗.png">
          </div>
          <div class="point"
               style="border-bottom: 1px solid rgba(41, 159, 251, .2);text-align:left;float: right;width: 70%;height:100%;">
            <div class="font-weight-bold" style="font-size: 1.1rem">{{ data.power ? data.power : '0' }}kw</div>
            <div style="font-size: 0.9rem">总能耗</div>
          </div>
        </div>
      </el-col>
      <el-col :span="2" style="width: 10%;height: 53px"></el-col>
      <el-col :span="8" style="text-align: center;">
        <div style="height: 53px;">
          <div
            style="border-bottom: 1px solid rgba(41, 159, 251, .2);width: 30%;height:100%;padding-top:10px;padding-right:10px;display: inline-block;text-align: right">
            <img src="../../../assets/images/comprehensive/总容量.png">
          </div>
          <div class="point"
               style="border-bottom: 1px solid rgba(41, 159, 251, .2);text-align:left;float: right;width: 70%;height:100%;">
            <div class="font-weight-bold" style="font-size: 1.1rem">{{ data.power ? data.pueValue : '0' }}</div>
            <div style="font-size: 0.9rem">PUE</div>
          </div>
        </div>
      </el-col>

    </el-row>
    <el-row>
      <el-col :span="2" style="width: 10%;height: 2px"></el-col>
      <el-col :span="8" style="margin-top:5px;border-bottom: 1px solid rgba(41, 159, 251, .2);"></el-col>
      <el-col :span="2" style="width: 10%;height: 2px"></el-col>
      <el-col :span="8" style="margin-top:5px;border-bottom: 1px solid rgba(41, 159, 251, .2);"></el-col>
    </el-row>
  </div>

</template>

<script>
import {getRealTimePue} from "@/network/ems-record.js"
export default {
  name: "EnergyEfficiency",
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  mounted() {
     this.getData();
  },
  watch: {
    spaceId() {
      this.getData();
    },
  },
  data() {
    return {
      data: {},
    }
  },
  methods: {
    getData() {
      this.data = {}
      getRealTimePue(this.spaceId).then(res => {
        if (res.code === 0) {
          this.data = res.data;
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
